import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { sharedColors } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';

export const NewAddressCard = () => {
  const navigate = useNavigate();

  const { primary, secondary } = useThemeColor();

  return (
    <Box
      onClick={() => {
        navigate('/hesabim/adres-ekle');
      }}
      sx={{
        p: 2.5,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        gap: 2,
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px dashed #ddd',
        borderRadius: 2,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: sharedColors.gray1,
        },
      }}
    >
      <Box
        sx={{
          py: 1.5,
          px: 1.75,
          border: '2px dashed #ccc',
          borderRadius: '50%',
          color: sharedColors.gray4,
        }}
      >
        <AddIcon fontSize='large' />
      </Box>

      <Button
        sx={{
          backgroundColor: primary,
          color: secondary,
          textTransform: 'none',
          fontWeight: 600,
          px: 2,
        }}
      >
        Adres Ekle
      </Button>
    </Box>
  );
};
